import themes from './theme';

const CONSTANTS = {
    themes,
    FAVORITE_KEY: 'favorites',
    SEARCH_URL_BASE: 'https://www.googleapis.com/youtube/v3/search',
};

export default CONSTANTS;
